'use client';

import { createContext, useCallback, useRef, useState } from 'react';

type CaptchaInstance = {
  reset: () => void;
};

export const Captcha = createContext<{
  token: string;
  setToken: (token: string) => void;
  instance: CaptchaInstance | null;
  setInstance: (ref: CaptchaInstance) => void;
}>({
  token: '',
  instance: null,
  setToken: (_: string) => {
    // do nothing
    return '';
  },
  setInstance: () => {
    // do nothing
  },
});

export function CaptchaProvider(props: { children: React.ReactNode }) {
  const [token, setToken] = useState<string>('');
  const instanceRef = useRef<CaptchaInstance | null>(null);

  const setInstance = useCallback((ref: CaptchaInstance) => {
    instanceRef.current = ref;
  }, []);

  return (
    <Captcha.Provider
      value={{ token, setToken, instance: instanceRef.current, setInstance }}
    >
      {props.children}
    </Captcha.Provider>
  );
}
